import { useEffect, useMemo, useRef, useState } from "react";
import {
  faEllipsisVertical,
  faPlus,
  faTrash,
  faFileExport,
  faUser,
  faMailForward,
  faPrint,
  faDownload,
  faBell,
  faAdd,
  faPhone,
  faStop,
  faCalendar,
  faShare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Button,
  Dropdown,
  Nav,
  Container,
} from "react-bootstrap";
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import "./InvoiceOrder.css";
import {
  downloadPdf,
  fetchTemporaryFilterData,
  formatDate,
  formatToINR,
  handleExportData,
  printPdf,
  sharePdf,
} from "../../Utils/helpers/commonhelper";
import InvoiceDetails from "./InvoiceDetails";
import { Filter } from "../../CommonComponents/Filter";
import { EmailModal } from "../detailPage/leads/EmailModal";
import { WhatsappModal } from "../../CommonComponents/WhatsappModal";
import { baseURL } from "../../Utils/constants/constant";
import { RxCrossCircled } from "react-icons/rx";
import { UpgradePlan } from "../../CommonComponents/UpgradePlan";
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard";
import { ColumnConfigurator } from "../../CommonComponents/ColumnConfigurator";
import { ManageListDropdown } from "../../CommonComponents/ManageListDropdown";
import { TableWrapper } from "../../CommonComponents/TableWrapper";
import { useGetEssentials } from "../../Utils/hooks/useGetEssentials";
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue";
import useCommonData from "../../Utils/actions/advanceFilteringAction";
import { FilterQueryString } from "../../CommonComponents/FilterQueryString";

export const InvoiceOrder = () => {

  // getting essentials for api fetching
  const { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType } = useGetEssentials()

  const invoiceMetadata = JSON.parse(
    localStorage.getItem("invoiceMetadata") || "{}"
  );

  const [showInvoiceOrderDetails, setShowInvoiceOrderDetails] = useState(false);
  const [isMyApproval, setMyApproval] = useState(false);
  const [allSalesOrder, setAllSalesOrder] = useState([]);
  const [departmentToDelete, setDepartmentToDelete] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  // delete modal loading state
  const [loading, setLoading] = useState(false);
  // States for using pagination
  // Calculate total pages

  const [limit, setLimit] = useState(25);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [inputSearch, setInputSearch] = useState("");
  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);
  const params = {
    limit,
    offset,
    search: search,
  };

  // states to store the filter data
  const [filterStates, setFilterState] = useState([]);
  // // lead owner state
  // const [leadOwner, setLeadOwner] = useState([
  //   {

  //     leadName: "",
  //     leadId: "",
  //   },
  // ]);
  // state for companies
  // const [company, setCompany] = useState([]);
  // // state for companies
  // const [contacts, setContacts] = useState([]);

  const [heading, setHeading] = useState("All Invoice");


  // loading state for temporary filter data to be hydrated
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false)
  const [invoiceFilterDataParams, setInvoiceFilterDataParams] = useGlobalState(
    "invoiceFilterDataParams",
    { currAdvFilter: null, applyFilterData: {} }
  )

  // curr advance filter to store the current filter type between "apply" and "save as" in advance filter for respective pagination in apply filter
  const [currAdvFilter, setCurrAdvFilter] = useState(
    () => invoiceFilterDataParams?.currAdvFilter || null
  )

  // global value state for applying the pagination to temporary filter data
  const [invoiceFilterValues, setInvoiceFilterValues] = useGlobalState("invoiceApplyFilterQueryValues")

  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null);
  // state for filter dropdown of quotations
  const [filterDropdown, setFilterDropdown] = useState(false);

  // for dropdown of the filter cards being created by the user
  const [filterCategoriesDropdown, setFilterCategoriesDrop] = useState(false);
  // state to store the advanced custom filter to fetch data on save
  const [customFilter, setCustomFilter] = useState(null)

  const filterCategoriesDropRef = useRef(null);

  // filter categories to render within the heading dropdown
  const [filterCategories, setFilterCategories] = useState([]);
  // filter seazrch bar input state
  const [filterSearchInput, setFilterSearchInput] = useState("");
  // Add states for filter pagination and search
  const [filterOffset, setFilterOffset] = useState(0);
  const filterLimit = (5);
  const [total_count, setTotalCount] = useState(0)
  const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("");
  const [filterPageCount, setFilterPageCount] = useState(0);
  // isediting state for undoing the edit state in the filter name update in the heading dropdown
  const [editingId, setEditingId] = useState(false);
  useEffect(() => {
    if (!filterSearchInput || filterSearchInput.trim() === "") {
      // If no search input, show all categories
      setFilteredCategories(filterCategories);
    } else {
      // Filter categories based on search input
      const filtered = filterCategories.filter((category) =>
        category.card_name
          .toLowerCase()
          .includes(filterSearchInput.toLowerCase())
      );
      setFilteredCategories(filtered);
    }
  }, [filterSearchInput, filterCategories]);
  // fitered categories to store the search input filter categories
  const [filteredCategories, setFilteredCategories] = useState([]);
  // const [openRow, setOpenRow] = useState(null);
  // filter state to store the data to pass to delete and edit handler for filter
  const [filterData, setFilterData] = useState(null);
  // edit value state fot the filter card name edit
  const [editValue, setEditValue] = useState();
  // delete state for filter
  const [confirmFilterDelete, setFilterDelete] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [invoiceIdToSend, setInvoiceIdToSend] = useState(null);
  const [invoiceData, setInvoiceData] = useState([]);
  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false);

  // poermissions for invoice
  // rbac permission object
  const [PERMISSION, _] = useLocalStorageState('permission')
  // const permission = customer.customer_details?.permission;
  const invoiceGrant = PERMISSION.invoice
  const isInvoice = invoiceGrant.isAuthorized;

  const invoiceStaticListOptions = [
    {
      key: "All Invoice",
      icon: <FontAwesomeIcon
        icon={faUser}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    }
  ]

  const dataToDisplay =
    !tempFilterData ? allSalesOrder : tempFilterData?.data;

  const hasDataToDisplay = dataToDisplay?.length > 0;

  // state for making sure the pagination position remains updated with respect to current page items
  const currPageItems = dataToDisplay?.length;

  const isFiltered = tempFilterData !== null && tempFilterData !== undefined;
  const pageCount = Math.ceil(
    (isFiltered
      ? (tempFilterData.total_count || 0)
      : (total_count || 0)
    ) / limit
  );

  const totalItems = isFiltered
    ? (tempFilterData?.total_count || 0)
    : (total_count);

  const displayStartItem = totalItems === 0
    ? 0
    : offset * limit + 1;

  const displayEndItem = totalItems === 0
    ? 0
    : Math.min(offset * limit + limit, totalItems);


  useEffect(() => {
    if (!isInitialized) {
      const lastHeading = invoiceMetadata?.filterType?.filterName
      setHeading(lastHeading || "All Invoice");
      setIsInitialized(true);
    }
  }, [isInitialized, invoiceMetadata]);

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, company, contacts } = useCommonData({
    leadOwner: true,
    leadSource: false,
    companies: true,
    contacts: true
  })

  //  filter dropdown options
  const dropdownOptions = [
    { value: "contact_id", label: "Contact", option: contacts },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "company_id", label: "Company Name", option: company },
    { value: "sale_no", label: "Sales Number" },
    { value: "invoice_date", label: "Invoice Date", type: "date-range" },
    { value: "due_date", label: "Due Date", type: "date-range" },
    { value: "invoice_number", label: "Invoice Number" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ];

  // sub filter dropdown option
  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
    { value: "between", label: "Between" },
  ];
  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ];

  // Debounced search effect
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim());
      setOffset(0);
    }, 300);
    return () => clearTimeout(debounceTimer);
  }, [inputSearch]);

  // edit handler for filter heading
  const handleFilterEdit = async () => {
    try {

      if (!editValue?.trim()) return
      if (!filterData) return

      const updatePayload = {
        customerId: customerId,
        user_login_id: loginUserId,
        filter_id: filterData.id,
        card_name: editValue,
        description: "",
        module_name: "invoice"
      };
      const res = await PutRequest(
        "common/updateFilterName",
        updatePayload,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );

      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Error Updating Filter")
        setFilterDropdown(false)
        return
      }

      setHeading(editValue.trim())
      // setIsEditing(false)
      setEditingId(null)
      setFilterDropdown(false)
      fetchFilterCardCategories()
      toast.success(res?.message)
    } catch (error) {
      toast.error("Error Updating Filter");
    }
  };
  // delete handler for filter delete
  const handleFilterDelete = async () => {
    try {
      if (filterData === null) return;
      const res = await DeleteRequest(
        `common/deleteFilter/${filterData.id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );
      if (res.status === "fail") {
        toast.error(res.message);
        return;
      }
      if (res.success === false) {
        toast.error(res.message);
      }
      setCustomFilter(null)
      setFilterDropdown(false);
      setFilterDelete(false);

      setHeading("All Invoice");
      filterCategories?.length !== 1 && fetchFilterCardCategories();
      filterCategories?.length === 1 && setFilterOffset(0)
      localStorage.setItem("invoiceMetadata", JSON.stringify({
        ...invoiceMetadata,
        filterType: {
          filterName: "All Invoice",
          id: null
        }
      }));
      fetchSalesOrder()
      toast.success(res.message);
    } catch (error) {
      toast.error("Error Deleting Filter");
    }
  };

  useEffect(() => {
    if (tempFilterData !== null) {
      setOffset(0);
    }
  }, [tempFilterData]);
  const handleFilterPageChange = (newOffset) => {
    setFilterOffset(newOffset.selected);
  };


  // useeeffect for fetching the created advance filters
  const fetchFilterCardCategories = async () => {
    try {
      const res = await GetRequest(
        `common/fetchFilterCard/${customerId}/invoice/${loginUserId}?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      );

      if (res.status === "fail" || res.success === false) {
        return;
      }

      setFilterCategories(res.data);

      // Calculate page count if total_count is available in response
      if (res.total_count) {
        setFilterPageCount(Math.ceil(res.total_count / filterLimit));
      }
    } catch (error) {
      toast.error("Error fetching filters");
    }
  };
  useEffect(() => {
    fetchFilterCardCategories();
  }, [heading, filterOffset, filterLimit, debouncedFilterSearch]);

  const applyFilterDataParams = {
    filterValues: invoiceFilterValues,
    currView: "list",
    offset: offset,
    limit: limit,
    module_name: "invoice",
    customerId: customerId,
    loginUserId: loginUserId,
    userType: userType,
    headers: headers,
    extras: extras,
    setTempFilterData: setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState: setFilterState,
    setFilterDropdown: setFilterDropdown,
  }

  useEffect(() => {
    setInvoiceFilterDataParams({
      currAdvFilter: currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: invoiceFilterValues,
        currView: "list",
        offset: offset,
        limit: limit,
      },
    })
  }, [currAdvFilter, invoiceFilterValues, offset, limit])

  useEffect(() => {
    if (
      currAdvFilter === "apply" &&
      invoiceFilterValues?.["filter_values"]?.length > 0
    ) {
      fetchTemporaryFilterData(invoiceFilterDataParams?.applyFilterData)
    }
  }, [invoiceFilterDataParams?.applyFilterData])

  const { endpoint, queryKey } = useMemo(() => {
    if (currAdvFilter === "apply") {
      return {
        endpoint: "",
        queryKey: ""
      }
    }

    // resetting state if current advance filter is not apply
    setInvoiceFilterValues({ filter_state: [], filter_values: [] })

    const customFilterId = invoiceMetadata?.filterType?.id
    const lowerHeading = heading
      ? heading?.toLowerCase()?.split(" ").join("_")
      : heading;
    if (!customFilter && !customFilterId && lowerHeading === "all_invoice") {
      return {
        endpoint: `invoice/fetchInvoice/${customerId}/${loginUserId}/${userType}`,
        queryKey: `fetchInvoice`
      }
    }

    if (customFilter || customFilterId) {
      const id = customFilter?.id || customFilterId
      return {
        endpoint: `invoice/fetchInvoice/${customerId}/${loginUserId}/${userType}/${id}`,
        queryKey: `filterQuery${id}`
      }
    }
    return {
      endpoint: "",
      queryKey: ""
    }
  }, [heading, filterCategories, isMyApproval, customFilter, currAdvFilter]);

  // Single useGetRequest call
  const {
    data: salesOrderData,
    error,
    refetch: fetchSalesOrder,
    isLoading,
    isError,
  } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    params
  );

  // storing all contacts to a state to use it in the custom dropdown for the dynamic fields
  useEffect(() => {
    if (currAdvFilter === "apply") return
    if (
      salesOrderData &&
      salesOrderData.filter_data &&
      salesOrderData.filter_data[0] &&
      salesOrderData.filter_data[0].filter_values
    ) {
      const values = salesOrderData.filter_data[0].filter_values;
      const parsedState = JSON.parse(values);
      const filteredArray = parsedState?.map((state) => {
        const dropdownValue = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        );

        return {
          id: state.label_name,
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownValue ? dropdownValue.label : state.label_name,
          option: dropdownValue.option,
          subFilterType: state.label_query,
          value:
            state.label_query === "between"
              ? { start: state.label_value[0], end: state.label_value[1] }
              : state.label_value,
        };
      });

      setFilterState(filteredArray);
    } else {
      setFilterState([]);
    }

    setAllSalesOrder(salesOrderData?.data);
    setTotalCount(salesOrderData?.["total_count"])
  }, [queryKey, salesOrderData]);



  const [detailPageId, setDetailPageId] = useState(null);
  // Handle page change from react-paginate
  const handlePageChange = (selectedItem) => {
    setOffset(selectedItem.selected);
  };

  const onDelete = (id) => {
    setDepartmentToDelete(id);
    setShowDeleteModal(true);
  };

  // Confirm delete and call API
  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = allSalesOrder.find((d) => d.id === departmentToDelete);

      const res = await DeleteRequest(
        `invoice/deleteInvoice/${departmentToDelete}/${customerId}/${loginUserId}`,
        { headers },
        extras
      );

      if (res?.status === "success") {
        setLoading(false)
        toast.success(res.message);
        await fetchSalesOrder();
      } else if (res.status === "fail") {
        setLoading(false)
        toast.error(res.message);
      }
    } catch (error) {
      setLoading(false)
      console.error("Delete error:", error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setDepartmentToDelete(null);
    }
  };

  const handleDetailPageClicked = (saleOrder) => {
    setDetailPageId(saleOrder?.id);
    setShowInvoiceOrderDetails(true);
  };

  const columnOptions = [
    // { key: "sn", label: "#",locked: true },
    { key: "invoice_number", label: "Invoice Number", mandatory: true },
    { key: "sale_no", label: "Sales Number" },
    { key: "invoice_date", label: "Invoice Date" },
    { key: "contact_name", label: "Customer Name" },
    { key: "confirmed", label: "Payment" },
    { key: "items", label: "Amount" },
    { key: "due_amount", label: "Due Amount" },
    { key: "due_date", label: "Invoice Due Date" },
  ];

  // Initialize columns for the table - ALL columns visible by default
  const [columns, setColumns] = useState(() => {
    const saved = invoiceMetadata?.visibleColumns;
    const allColumnKeys = columnOptions?.map(col => col.label);
    if (saved) {
      try {
        return saved;
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  const handleCloseEmailModal = () => {
    setShowEmailModal(false);
    setInvoiceIdToSend(null);
    setInvoiceData([]);
  };

  const setStopReminder = async () => {
    try {
      const payload = {
        customer_id: customerId,
        invoice_id: invoiceIdToSend?.id,
        reminder: "no",
      };
      const res = await PutRequest(
        `invoice/setReminder`,
        payload,
        { headers },
        extras
      );

      if (res.status === "fail" || res.status !== "success") {
        return toast.error(res.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setInvoiceIdToSend(null);
      setShowReminderModal(false);
    }
  };

  const handleShareInvoice = async (saleOrder) => {
    if (!saleOrder?.id) {
      toast.error("Invoice not found!");
      return;
    }

    const invoiceCustomerId = saleOrder?.customer_id || customerId;

    await sharePdf(
      `${baseURL}/invoice/downloadInvoice/${invoiceCustomerId}/${saleOrder.id}`,
      headers,
      "download",
      loginUserId,
      setLoading,
      `invoice_${saleOrder.invoice_number}`
    );
  };

  const handleAddPaymentClick = (saleOrder) => {
    const dataToSend = {
      key1: saleOrder?.id,
      key2: saleOrder?.contact_id,
      key3: saleOrder?.contact_name || saleOrder?.contact_full_name,
    };

    navigate("/createpayment", { state: dataToSend });
  };

  if (!isInvoice) {
    return <UpgradePlan moduleName="Invoice Order" />
  }

  if (!invoiceGrant?.isView) {
    return <AuthorizationCard />
  }


  const tableHeader = () => (<thead style={{ zIndex: 101 }}>
    <tr>
      <th
        className="text-start  pinned-column last-pinned-column  bulk-selection-cell customize-cell-width"
        style={{
          width: 60,
          minWidth: 60,
          maxWidth: 60,
          left: 0,
        }}
      >
        <span>#</span>
      </th>
      {columns?.map((col, index) => (
        <th
          key={`header - ${index} `}
          style={{
            textAlign:
              col !== "Invoice Number" &&
                col !== "Customer Name" &&
                col !== "Sales Number"
                ? "center"
                : "left",
          }}
        >
          {col}
        </th>
      ))}
      <th></th>
    </tr>
  </thead>)

  const tableBody = () => ((dataToDisplay?.map((saleOrder, index) => (
    <tr key={saleOrder?.id || index}>
      <td>{offset * limit + index + 1}</td>
      {columns?.map((col, cellIndex) => {
        switch (col) {
          case "Invoice Number":
            return (
              <td
                key={`cell - ${index} -${cellIndex} `}
                onClick={() => handleDetailPageClicked(saleOrder)}
                style={{ color: "#0099ff", cursor: "pointer" }}
                data-bs-target="#saleOrderDetails"
                data-bs-toggle="offcanvas"
              >
                {saleOrder.invoice_number}
              </td>
            );

          case "Sales Number":
            return (
              <td key={`cell - ${index} -${cellIndex} `}>
                {saleOrder.sale_no}{" "}
                <i className="fa-regular fa-envelope"></i>
              </td>
            );

          case "Invoice Date":
            return (
              <td key={`cell - ${index} -${cellIndex} `} style={{ textAlign: "center" }}>
                {formatDate(saleOrder.invoice_date)}
              </td>
            );

          case "Customer Name":
            return (
              <td key={`cell - ${index} -${cellIndex} `}>
                {saleOrder.contact_name || `${saleOrder.salutation} ${saleOrder.first_name} ${saleOrder.last_name}`}
              </td>
            );

          case "Payment":
            return (
              <td key={`cell - ${index} -${cellIndex} `} style={{ textAlign: "center" }}>
                {(Number(JSON.parse(saleOrder.items)[0]?.["grand-total"]) || 0) -
                  (Number(saleOrder?.payment_amount) || 0) !== 0 ? (
                  <span style={{ color: "darkorange" }}>Pending</span>
                ) : (
                  <span style={{ color: "darkgreen" }}>Paid</span>
                )}
              </td>
            );

          case "Amount":
            return (
              <td key={`cell - ${index} -${cellIndex} `} style={{ textAlign: "center" }}>
                {formatToINR(
                  JSON.parse(saleOrder.items)[0]?.["grand-total"] || 0
                )}
              </td>
            );

          case "Due Amount":
            return (
              <td key={`cell - ${index} -${cellIndex} `} style={{ textAlign: "center" }}>
                {formatToINR(
                  (Number(JSON.parse(saleOrder.items)[0]?.["grand-total"]) || 0) -
                  (Number(saleOrder?.payment_amount) || 0)
                )}
              </td>
            );

          case "Invoice Due Date":
            return (
              <td key={`cell - ${index} -${cellIndex} `} style={{ textAlign: "center" }}>
                {formatDate(saleOrder?.due_date)}
              </td>
            );

          case "Due Date":
            return (
              <td key={`cell - ${index} -${cellIndex} `} style={{ textAlign: "center" }}>
                {formatDate(saleOrder?.due_date)}
              </td>
            );

          default:
            return <td key={`cell - ${index} -${cellIndex} `}>-</td>;
        }
      })}
      <td style={{ textAlign: "center" }}>
        <div className="endTdDiv">
          <Dropdown
            as="div"
            className="dropdownsWithoutToggle"
          // onToggle={(isOpen) =>
          //   setOpenRow(isOpen ? saleOrder?.id : null)
          // }
          >
            <Dropdown.Toggle
              as={Nav.Link}
              className="header-link"
            >
              <FontAwesomeIcon
                className="text-muted"
                style={{
                  width: "15px",
                  height: "15px",
                  color: "#536485",
                }}
                icon={faEllipsisVertical}
              />
              {/* </button> */}
            </Dropdown.Toggle>
            <Dropdown.Menu
              align={"end"}
              style={{
                width: "8rem",
                inset: "0px auto auto 0px",
                boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                position: "absolute",
                marginTop: "-22px",
                marginRight: "25px",
                minWidth: "3rem",
              }}
            >
              <Dropdown.Item
                href="#"
                className="d-flex align-items-center"
                onClick={() => {
                  if (!invoiceGrant?.isDelete) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  onDelete(saleOrder.id)
                }}
                style={{
                  width: "15px",
                  height: "15px",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />
                Delete
              </Dropdown.Item>

              <div className="endTdDiv">
                <Dropdown
                  as="div"
                  className="dropdownsWithoutToggle"
                >
                  <Dropdown.Toggle
                    as={Nav.Link}
                    className="header-link"
                    style={{
                      marginLeft: "54%",
                      fontSize: "14px",
                    }}
                  >
                    <FontAwesomeIcon
                      className="text-muted"
                      style={{
                        width: "15px",
                        height: "15px",
                        color: "#536485",
                        marginRight: "9px",
                      }}
                      icon={faMailForward}
                    />
                    Send
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align={"end"}
                    style={{
                      width: "8rem",
                      inset: "0px auto auto 0px",
                      boxShadow:
                        "rgb(215, 215, 215) 0px 0px 15px",
                      position: "absolute",
                      marginTop: "-22px",
                      marginRight: "25px",
                      minWidth: "3rem",
                    }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        setShowWhatsappModal(true);
                        setInvoiceIdToSend(saleOrder?.id);
                      }}
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                        fontSize: "14px",
                        marginBottom: "9px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPhone}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      WhatsApp
                    </Dropdown.Item>

                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        setShowEmailModal(true);
                        setInvoiceIdToSend(saleOrder?.id);
                        setInvoiceData(saleOrder);
                      }}
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faMailForward}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      Email
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              <div className="endTdDiv">
                <Dropdown
                  as="div"
                  className="dropdownsWithoutToggle"
                >
                  <Dropdown.Toggle
                    as={Nav.Link}
                    className="header-link"
                    style={{
                      marginLeft: "54%",
                      fontSize: "14px",
                    }}
                  >
                    <FontAwesomeIcon
                      className="text-muted"
                      style={{
                        width: "15px",
                        height: "15px",
                        color: "#536485",
                        marginRight: "9px",
                      }}
                      icon={faPrint}
                    />
                    Print/PDF
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align={"end"}
                    style={{
                      width: "8rem",
                      inset: "0px auto auto 0px",
                      boxShadow:
                        "rgb(215, 215, 215) 0px 0px 15px",
                      position: "absolute",
                      marginTop: "-22px",
                      marginRight: "25px",
                      minWidth: "3rem",
                    }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        printPdf(
                          `${baseURL}/invoice/downloadInvoice/${customerId}/${saleOrder?.id}`,
                          headers,
                          "print", `${loginUserId}`,
                          setLoading
                        );
                      }}
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                        marginBottom: "9px",
                        fontSize: "14px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPrint}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      Print
                    </Dropdown.Item >

                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        downloadPdf(
                          `${baseURL}invoice/downloadInvoice/${customerId}/${saleOrder?.id}`,
                          headers,
                          "download",
                          "invoice_order", `${loginUserId}`,
                          setLoading
                        );
                      }}
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faDownload}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      PDF
                    </Dropdown.Item>
                  </Dropdown.Menu >
                </Dropdown >
              </div >
              <div className="endTdDiv">
                <Dropdown
                  as="div"
                  className="dropdownsWithoutToggle"
                >
                  <Dropdown.Toggle
                    as={Nav.Link}
                    className="header-link"
                    style={{
                      marginLeft: "54%",
                      fontSize: "14px",
                    }}
                  >
                    <FontAwesomeIcon
                      className="text-muted"
                      style={{
                        width: "15px",
                        height: "15px",
                        color: "#536485",
                        marginRight: "9px",
                      }}
                      icon={faBell}
                    />
                    Reminder
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    align={"end"}
                    style={{
                      width: "8rem",
                      inset: "0px auto auto 0px",
                      boxShadow:
                        "rgb(215, 215, 215) 0px 0px 15px",
                      position: "absolute",
                      marginTop: "-22px",
                      marginRight: "25px",
                      minWidth: "3rem",
                    }}
                  >
                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      onClick={() => {
                        setShowReminderModal(true);
                        setInvoiceIdToSend(saleOrder?.id);
                      }}
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                        marginBottom: "9px",
                        fontSize: "14px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faStop}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      Stop
                    </Dropdown.Item>

                    <Dropdown.Item
                      href="#"
                      className="d-flex align-items-center"
                      style={{
                        width: "15px",
                        height: "15px",
                        cursor: "pointer",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faCalendar}
                        style={{
                          width: "16px",
                          height: "16px",
                          marginRight: "9px",
                          color: "#5e5f60",
                        }}
                      />
                      Follow
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <Dropdown.Item
                href="#"
                className="d-flex align-items-center"
                onClick={(e) => {
                  e.preventDefault();
                  if (!invoiceGrant?.isExport) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  handleShareInvoice(saleOrder);
                }}
                style={{
                  width: "15px",
                  height: "15px",
                  cursor: "pointer",
                  marginTop: "4px",
                }}
              >
                <FontAwesomeIcon
                  icon={faShare}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />
                Share
              </Dropdown.Item>
              <Dropdown.Item
                href="#"
                className="d-flex align-items-center"
                onClick={() => {
                  if (!invoiceGrant?.isCreate) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  handleAddPaymentClick(saleOrder);
                }}
                style={{
                  width: "15px",
                  height: "15px",
                  cursor: "pointer",
                  marginTop: "4px",
                }}
              >
                <FontAwesomeIcon
                  icon={faAdd}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />
                Payment
              </Dropdown.Item>
            </Dropdown.Menu >
          </Dropdown >
        </div >
      </td >
    </tr >
  ))))

  return (
    <>
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmedDelete}
        isLoading={loading}
        message={"Are you sure you want to permanently delete this invoice?"}
      />

      {showEmailModal && (
        <EmailModal
          show={showEmailModal}
          onClose={handleCloseEmailModal}
          id={invoiceIdToSend}
          pipelineId={""}
          customerId={customerId}
          loginId={loginUserId}
          headers={headers}
          extras={extras}
          data={invoiceData} // Pass lead data for pre-populating emails
          module_name={"invoice"}
        />
      )}

      {showWhatsappModal && (
        <WhatsappModal
          whatsappModalOpen={showWhatsappModal}
          setWhatsAppModalOpen={setShowWhatsappModal}
          id={invoiceIdToSend}
          module_name={"invoice"}
        />
      )}

      {showReminderModal && (
        <>
          <div
            className="modal  show fade d-block"
            tabIndex="-1"
            role="dialog"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content " style={{ marginTop: "120px" }}>
                <div className="modal-header d-flex justify-content-between">
                  <h5 className="modal-title">Stop Remender</h5>
                  <button
                    type="button"
                    className="btn"
                    style={{
                      background: "none",
                      border: "none",
                      fontSize: "1.8rem",
                      cursor: "pointer",
                      color: "#888",
                      marginTop: "-20px",
                      opacity: "0.4",
                    }}
                    onClick={() => setShowReminderModal(false)}
                  >
                    <RxCrossCircled />
                  </button>
                </div>

                <div className="modal-body">
                  Are you sure you want to stop the reminder?
                </div>

                <div className="modal-footer" style={{ borderTop: "none" }}>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={() => {
                      setStopReminder();
                    }}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowReminderModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      <div className=" pb-1 d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-2">
          <h3
            className="mb-0 d-flex gap-2 align-items-center"
            style={
              isMyApproval
                ? {
                  fontSize: 14,
                  cursor: "pointer",
                  textTransform: "capitalize",

                }
                : {
                  whiteSpace: "nowrap",
                  fontWeight: 300,
                  fontSize: "22px",
                  cursor: "pointer",
                  textTransform: "capitalize",
                  color: "#4dabf4"
                }
            }
            onClick={() => {
              setMyApproval(false);
            }}
          >
            {heading}
          </h3>

          <ManageListDropdown
            heading={heading}
            setHeading={setHeading}
            categories={filterCategories}
            storageKey="invoiceMetadata"
            metadata={invoiceMetadata}
            setTempFilterData={setTempFilterData}
            onEdit={(c) => setFilterData(c)}
            onDelete={(c) => {
              setFilterData(c)
              setFilterDelete(true)
            }}
            onUpdate={(c) => {
              setFilterData(c)
              handleFilterEdit()
            }}
            staticOptions={invoiceStaticListOptions}
            filterOffset={filterOffset}
            setFilterOffset={setFilterOffset}
            handleFilterPageChange={handleFilterPageChange}
            filterPageCount={filterPageCount}
            filterLimit={filterLimit}
            editValue={editValue}
            setEditValue={setEditValue}
            editingFilterId={editingId}
            setEditingFilterId={setEditingId}
            canEdit_canDownload={true}
            setCustomFilter={setCustomFilter}
            setCurrAdvFilter={setCurrAdvFilter}
            filterQueryKey={"invoiceApplyFilterQueryValues"}
          />
          {confirmFilterDelete && (
            <DeleteModal
              show={confirmFilterDelete}
              onClose={() => setFilterDelete(false)}
              onConfirm={() => handleFilterDelete(filterData)}
              isLoading={loading}
              message={"Are you sure you want to delete thƒis filter?"}
            ></DeleteModal>
          )}
        </div>

        <div
          className="d-flex align-items-center gap-1"
          style={{
            height: "35px",
            position: "absolute",
            right: 0,
            top: "0.5rem",
          }}
        >
          {/* search bar */}
          <div className=" position-relative">
            <input
              type="text"
              style={{
                fontSize: "12px",
                paddingLeft: "36px",
                height: "35px",
              }}
              className="form-control "
              value={inputSearch}
              onChange={(e) => {
                setInputSearch(e.target.value);
                setOffset(0);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  setSearch(inputSearch);
                  setOffset(0);
                }
              }}
            />
            <i
              className="fa-solid fa-magnifying-glass"
              style={{
                position: "absolute",
                marginTop: "-26px",
                zIndex: 1,
                marginLeft: "13px",
              }}
            ></i>
            {inputSearch?.length > 0 && (
              <i
                className="fa-solid fa-xmark"
                style={{
                  position: "absolute",
                  marginTop: "-26px",
                  zIndex: 1,
                  right: 0,
                  marginRight: "13px",
                  cursor: "pointer",
                }}
                onClick={() => setInputSearch("")}
              ></i>
            )}
          </div>
          {/* advance filtering */}
          <Filter
            canEdit_canDownload={true}
            filterDropdown={filterDropdown}
            setFilterDropdown={setFilterDropdown}
            dropdownOptions={dropdownOptions}
            filterState={filterStates}
            setFilterState={setFilterState}
            setHeading={setHeading}
            subFilter={subFilter}
            module_name={"invoice"}
            customSubFilter={customSubFilter}
            setTempFilterData={setTempFilterData}
            filterEndpoint={"common/filterQuery"}
            view="list"
            setCustomFilter={setCustomFilter}
            storageKey={'invoiceMetadata'}
            metadata={invoiceMetadata}
            setCurrAdvFilter={setCurrAdvFilter}
            filterQueryKey={"invoiceApplyFilterQueryValues"}
          ></Filter>

          <ColumnConfigurator
            columnOptions={columnOptions}
            columns={columns}
            setColumns={setColumns}
            storageKey="invoiceMetadata"
            metadata={invoiceMetadata}
          />

          <Dropdown
            as="div"
            className="dropdownsWithoutToggle"
            style={{ zIndex: 101 }}
          >
            <Dropdown.Toggle as={Nav.Link} className="header-link">
              <button
                className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                style={{
                  fontSize: "1rem",
                  alignItems: "center",
                  height: "35px",
                  width: "2.5rem",
                }}
              >
                {" "}
                <FontAwesomeIcon
                  style={{
                    width: "15px",
                    height: "15px",
                  }}
                  icon={faEllipsisVertical}
                />
              </button>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="defaultDropdown dropdown-menu-end "
              style={{ width: "11rem", padding: "12px 0px", right: "3.4rem" }}
            >
              <Dropdown.Item
                className="d-flex align-items-center"
                onClick={() => {
                  if (!invoiceGrant?.isExport) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  handleExportData([], "invoice_order", headers, extras)
                }}
              >
                <FontAwesomeIcon
                  icon={faFileExport}
                  style={{
                    width: "16px",
                    height: "16px",
                    marginRight: "9px",
                    color: "#5e5f60",
                  }}
                />{" "}
                Export Data
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <Button
            type="button"
            className="btn btn-default"
            style={{
              maxHeight: "35px",
              color: "white",
              fontSize: "14px",
              border: "1px solid",
              alignItems: "center",
              paddingRight: "10px",
              backgroundColor: "rgb(122, 58, 94)",
            }}
            onClick={() => {
              if (!invoiceGrant?.isCreate) {
                toast.warning("You are not authorized for this action!")
                return
              }
              navigate("/createInvoiceOrder")
            }}
          >
            <FontAwesomeIcon icon={faPlus} /> Add
          </Button>
        </div>
      </div>

      {/* to show the current applied filters  */}
      <FilterQueryString
        filterValues={invoiceFilterValues?.filter_state}
        setCurrAdvFilter={setCurrAdvFilter}
        setTempFilterData={setTempFilterData}
        setFilterState={setFilterState}
        setFilterValues={setInvoiceFilterValues}
      />

      <Container
        fluid
        style={{
          fontFamily: "'Poppins', sans-serif",
          height: "calc(100vh - 14rem)",
          padding: 0,
          animation: "cardEntry 1s ease-out forwards",
        }}
        className="mt-3 p-0"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            borderRadius: "7px"
          }}
          className='position-relative container-table '
        >
          <TableWrapper
            isLoading={isLoading || tempFilterDataLoading}
            hasData={hasDataToDisplay}
            tableHeader={tableHeader()}
            tableBody={tableBody()}
            displayStartItem={displayStartItem}
            displayEndItem={displayEndItem}
            totalItems={totalItems}
            currPageItems={currPageItems}
            offset={offset}
            setOffset={setOffset}
            limit={limit}
            setLimit={setLimit}
            handlePageChange={handlePageChange}
            effectivePageCount={pageCount}
            columnLabels={columns}
          />
        </div>
        {/* {console.log("editData", editData)} */}
        {showInvoiceOrderDetails && (
          <InvoiceDetails
            show={showInvoiceOrderDetails}
            setShowSalesOrderDetails={setShowInvoiceOrderDetails}
            detailPageId={detailPageId}
            handleClose={() => setShowInvoiceOrderDetails(false)}
          />
        )}
      </Container >
    </>
  );
};
